export default "__VITE_ASSET__CDJ_kXwa__"